import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
//primereact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
//components
import Input from "../../../components/input/Input";
import { onSubmitEditRegistrationType } from "../../../services/Settings/RegistrationType/EditRegistrationType";

const ModalEditRegistrationType = ({
  visible,
  rowData,
  setVisible,
  loadingAccount,
  refresh,
}) => {
  const {
    control: controlType,
    handleSubmit: handleType,
    reset: resetType,
    formState: { errors },
    setValue,
  } = useForm();

  function sendType(data) {
    setVisible(false);
    onSubmitEditRegistrationType(resetType, loadingAccount, setVisible, data)
      .then(() => {
        // Após a conclusão bem-sucedida de onSubmitCurrentAccount,
        // chame a função refresh
        refresh();
      })
      .catch((error) => {
        // Trate erros, se necessário
        console.error("Erro ao enviar a conta corrente:", error);
      });
  }
  useEffect(() => {
    if (rowData) {
      // Para os campos de tipo de cadastro
      setValue("id", rowData.id);
      setValue("name", rowData.description);
    }
  }, [rowData, onSubmitEditRegistrationType]);
  //  console.log(rowData);
  return (
    <>
      <Dialog
        header="Alterar Tipo de Cadastro"
        id="modal_cad"
        className="rounded-4"
        onHide={() => setVisible(false)}
        visible={visible}
        style={{ width: window.innerWidth <= 992 ? "85vw" : "40vw" }}
      >
        <div className="inline-flex align-items-center">
          <p>
            {" "}
            <i className="pi pi-user"></i> Informações do tipo de cadastro
          </p>
        </div>

        <form onSubmit={handleType(sendType)}>
          <div className="">
            <div className="col-md-3">
              <Input

                className="d-none"
                control={controlType}
                defaultValue={rowData.id}
                name="id"
                id="id"
                label=""
                errors={errors}
              />
            </div>

            <div className="row">
              <div className="col-md-12 mb-4 ">
                <Input
                  isRequired={true}
                  id="name"
                  className="w-100"
                  control={controlType}

                  name="name"
                  label="Descrição"
                  errors={errors}
                />
              </div>
              <div className="text-center">
                <Button
                  rounded
                  label="Alterar"
                  icon="bi bi-pencil-square"
                  type="submit"
                  className="p-inputtext-sm m-auto"
                />
              </div>
            </div>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default ModalEditRegistrationType;
